@if (!isNewEDPScoreboard) {
    <div class="event-name">
        <ms-favourite-event-toggle class="participant-favourite" [event]="event" />
        <span class="participant-name">{{ event.name }} </span>
    </div>
    @if (score && score.final && score.current && score.type && event.sport.id === sportType.Cycling) {
        <div>
            @if (score.type === 'km') {
                <span class="score">{{ score.current }}/{{ score.final }}{{ score.type }}</span>
            }
            @if (score.type === 'Stage') {
                <span class="score">{{ sitecoreEventDetails.eventDetails.Stage }} {{ score.current }}/{{ score.final }}</span>
            }
            @if (score.type === 'Lap') {
                <span class="score">{{ sitecoreEventDetails.eventDetails.Lap }} {{ score.current }}/{{ score.final }}</span>
            }
        </div>
    }
    @if (event.sport.id === sportType.Golf || !(score && score.final && score.current && score.type)) {
        <div class="event-live">
            <span>{{ sitecore.freeBetOverview.messages?.Live }}</span>
        </div>
    }
} @else {
    <div class="event-header-live">
        <i class="live-icon"></i>
        <ms-event-timer [live]="event.live" [start]="event.startDate" [scoreboard]="event.scoreboard" [eventId]="event.sport.id" />
    </div>
    <div class="participant-info">
        @if (showCompetitionLogo) {
            <ms-competition-logo [sportId]="event.sport.id" [leagueId]="event.league.id" [imageProfile]="event.league.imageProfile" />
        } @else {
            <ms-participant-image
                class="participant-image"
                [participantImage]="event.league.imageProfile"
                [sportId]="event.sport.id"
                [showFallback]="isNewEDPScoreboard" />
        }
        <div class="participant-name">
            {{ event.name }}
            <span class="participant-country">{{ event.league.name }}</span>
        </div>
    </div>
}
